import { assert } from '@ember/debug';

/**
 * @typedef WalkthroughStep
 * @property {String} name - identifier for the current step.
 * @property {String} targetElement - Selector of the Element the popper should attach to.
 * @property {Component} popoverComponent - Ember component to render as the popover.
 *   If unspecified, the popoverComponent specified on the Walkthrough will be used
 * @property {String} text - Popover text.
 * @property {String} buttonText - Popover button text.
 * @property {String} imageUrl - Popover image url.
 * @property {String} imageAltText - Popover image alt text
 *   Generally you should need to specify placement only.
 * @property {String} placement - Position of the popover relative to the target element.
 *   Syntax is `(bottom|top|right|left)-[start|end]`, see https://popper.js.org/popper-documentation.html#Popper.placements.
 * @property {String} offset - Fine tune the position of the popover, see https://popper.js.org/popper-documentation.html#modifiers..offset
 * @property {String} [pointerEnabled] - Whether the pointer should be shown.
 * @property {String} [animate] - One of fly-(up|right|down|left)
 * @property {Boolean} [showProgressText] - determines if the popover shows the "x of x" text in the footer
 */

const DEFAULTS = {
  placement: 'bottom',
  pointerEnabled: true,
  animate: 'fly-down',
  offset: 0,
  showProgressText: true
};
export default class WalkthroughStep {
  constructor(params) {
    Object.assign(this, DEFAULTS, params);
    assert('name required', this.name);
    assert('targetElement required', this.targetElement);
    assert('text required', this.text);
    assert('placement required', this.placement);
    if (this.imageUrl) {
      assert('image alt required', this.imageAltText);
    }
  }
  buildPopperOptions(additionOptions) {
    const options = {
      placement: this.placement,
      modifiers: {
        preventOverflow: {
          // Allow the popover to overflow outside the target element's parent
          enabled: false
        },
        hide: {
          // Hide should also be disabled if prevent overflow is disabled
          enabled: false
        },
        flip: {
          // Don't try to flip the popper if it will overflow the screen
          enabled: false
        },
        offset: {
          offset: this.offset
        }
      }
    };
    return Object.assign({}, options, additionOptions);
  }
}